/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { Button } from 'react-bootstrap';

import {
  config,
  columns,
  defaultSorts,
  attributionTitleFilters
} from './config';
import PageHeader from '../../components/PageHeader';
import AttributionTitleFilters from './AttributionTitleFilters';
import TitleBanner from '../../components/TitleBanner';
import { extractFilterValues } from '../../utils/filters';
import GroupedTable from './GroupedTable';
import InlineQuery from '../../components/InlineQuery';

const AttributionTitle = ({
  blocked,
  filters,
  queries,
  filtersActions: { getFiltersForPageAsync, updateFilters, clearFilters },
  queryActions: { runFormattedInlineQueriesForPage },
  segmentActions: { openAudienceSegmentWindow },
  allowedCountries
}) => {
  const [selectedFilters, setSelectedFilters] = useState(
    extractFilterValues(filters.fields)
  );
  const [showTable, setShowTable] = useState(false);

  // eslint-disable-next-line
  const [platformParams, setPlatformParams] = useState(
    document.referrer.includes('/attribution/platform') &&
      window.location.search.includes('=title') &&
      localStorage.getItem('attributionPlatformParams')
      ? localStorage.getItem('attributionPlatformParams')
      : ''
  );

  const updateQueries = () => {
    if (showTable) {
      const filterOverrides = {};

      runFormattedInlineQueriesForPage(config.ATTRIBUTION_TITLE_FILTERS, {
        ...filters.fields,
        ...filterOverrides
      });
    }
  };

  useEffect(() => {
    if (!blocked) {
      if (filters.fields.country) {
        const f = filters.fields.country;
        if (f.value) {
          let i;
          for (i = 0; i < f.value.length; i += 1) {
            f.value[i].base = f.value[i].value;
            f.value[i].state = 'included';
          }
        }
      }

      const values = extractFilterValues(filters.fields);
      const hasNewValues = !isEqual(values, selectedFilters);
      const contentFields = attributionTitleFilters.content;
      let hasContentValues = false;

      values.forEach(v => {
        const [k] = v.split(':');
        if (contentFields.filter(cf => cf.id === k).length > 0) {
          hasContentValues = true;
        }
      });
      setShowTable(hasContentValues);

      if (hasNewValues) {
        setSelectedFilters(values);
      }

      if (hasNewValues) {
        updateQueries();
      }

      if (
        selectedFilters?.length === 0 &&
        !Object.keys(filters.fields).length
      ) {
        // handle "clear all" from TabbedFilter component
        getFiltersForPageAsync(config.ATTRIBUTION_TITLE_PAGE_ID);
      }
    }
  }, [filters.fields]);

  useEffect(() => {
    updateQueries();
  }, [showTable]);

  useEffect(() => {
    getFiltersForPageAsync(config.ATTRIBUTION_TITLE_PAGE_ID);
    document.title = 'Platform Attribution | CVM Insights';
  }, []);

  // When the platform view button is clicked
  const loadTitleViewForSelected = () => {
    window.location = `/attribution/platform/?${platformParams}`;
  };

  return (
    <>
      <TitleBanner>
        <PageHeader
          title="Platform Attribution"
          tooltip="The Platform Attribution tool lets you see where viewers watched at both the platform and title level. You can use the toggle to switch between views. TV Time began collecting this data in June 2020, so the all-time range for this tool is from June 2020 to the present. TV Time users indicate where they watched a title, or they can choose from options like Other, Unofficial, Originating Network (for TV shows), or Theater (for Movies, added February 2022). Consider these factors when using this dataset."
        />
      </TitleBanner>

      <div className="tvt-title-attribution__viewtoggle">
        <div>
          <a href="/attribution/platform">Platform View</a>
        </div>
        <div className="tvt-title-attribution__divider">|</div>
        <div>Title View</div>
      </div>

      <hr />

      {!showTable && (
        <section className="tvt-main__content">
          <AttributionTitleFilters
            filterFields={filters.fields}
            openSegment={openAudienceSegmentWindow}
            showTable={showTable}
            onApply={updateFilters}
            onReset={clearFilters}
          />
        </section>
      )}
      {showTable && (
        <>
          <AttributionTitleFilters
            filterFields={filters.fields}
            openSegment={openAudienceSegmentWindow}
            showTable={showTable}
            onApply={updateFilters}
            onReset={clearFilters}
          />

          {showTable && (
            <>
              <Button
                className={
                  platformParams
                    ? 'tvt-attribution-platform__title-viewership-button'
                    : 'hidden'
                }
                onClick={loadTitleViewForSelected}
              >
                Back To Platform Report
              </Button>

              <div className="tvt-attribution-title__charts-wrapper">
                <>
                  <InlineQuery
                    useChildForLoading
                    query={queries.attributionTitle}
                  >
                    {query => (
                      <GroupedTable
                        data={query.data}
                        headerFormatter={columns}
                        defaultSorts={defaultSorts}
                        view="attributionTitle"
                        height={438}
                        filters={filters.fields}
                        showRank={false}
                        queryMeta={
                          config.ATTRIBUTION_TITLE_FILTERS.queries
                            .attributionTitle
                        }
                      />
                    )}
                  </InlineQuery>
                </>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default AttributionTitle;
